
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="057ad2ba-d577-5484-93ca-3a6cf477cf88")}catch(e){}}();
(function initHanezzaHomeQualityFixes(root) {
  'use strict';

  if (!root || !root.document) return;

  var doc = root.document;
  var HOME_TITLE = 'Büyük Beden Kadın Giyim ve Şık Tasarımlar | Hanezza';
  var applied = false;

  function isHomepage() {
    return root.location.pathname === '/' || root.location.pathname === '';
  }

  function safeId(value) {
    return String(value || 'element')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'element';
  }

  function setMeta(property, value) {
    var selector = 'meta[property="' + property + '"], meta[name="' + property + '"]';
    var element = doc.querySelector(selector);
    if (element) element.setAttribute('content', value);
  }

  function applyHomepageTitle() {
    doc.title = HOME_TITLE;
    setMeta('og:title', HOME_TITLE);
    setMeta('twitter:title', HOME_TITLE);
  }

  function updateReferences(oldId, newId, scope) {
    if (!oldId || oldId === newId) return;
    var rootNode = scope || doc;
    ['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'href'].forEach(function (attribute) {
      rootNode.querySelectorAll('[' + attribute + ']').forEach(function (element) {
        var value = element.getAttribute(attribute);
        if (!value) return;
        if (attribute === 'href' && value === '#' + oldId) {
          element.setAttribute(attribute, '#' + newId);
          return;
        }
        var tokens = value.split(/\s+/).map(function (token) {
          return token === oldId ? newId : token;
        });
        element.setAttribute(attribute, tokens.join(' '));
      });
    });
  }

  function fixDuplicateFormIds() {
    var forms = Array.prototype.slice.call(doc.querySelectorAll('form#contact_form'));
    forms.forEach(function (form, index) {
      var section = form.closest('[id^="shopify-section-"]');
      var suffix = section && section.id ? section.id.replace('shopify-section-', '') : String(index + 1);
      var nextId = 'contact-form-' + safeId(suffix);
      form.dataset.hanezzaOriginalId = 'contact_form';
      form.id = nextId;
      updateReferences('contact_form', nextId, section || doc);
    });
  }

  function fixDuplicateSvgIds() {
    var groups = {};
    doc.querySelectorAll('svg[id]').forEach(function (svg) {
      groups[svg.id] = groups[svg.id] || [];
      groups[svg.id].push(svg);
    });

    Object.keys(groups).forEach(function (id) {
      if (groups[id].length < 2) return;
      groups[id].forEach(function (svg, index) {
        var nextId = safeId(id) + '-home-' + (index + 1);
        svg.id = nextId;
        svg.querySelectorAll('*').forEach(function (element) {
          Array.prototype.slice.call(element.attributes || []).forEach(function (attribute) {
            if (attribute.value.indexOf('#' + id) !== -1) {
              element.setAttribute(attribute.name, attribute.value.replace(new RegExp('#' + id + '\\b', 'g'), '#' + nextId));
            }
          });
        });
      });
    });
  }

  function reserveImageDimensions(image) {
    if (!image || image.hasAttribute('width') && image.hasAttribute('height')) return;
    if (image.naturalWidth > 0 && image.naturalHeight > 0) {
      if (!image.hasAttribute('width')) image.setAttribute('width', String(image.naturalWidth));
      if (!image.hasAttribute('height')) image.setAttribute('height', String(image.naturalHeight));
      return;
    }
    image.addEventListener('load', function onImageLoad() {
      reserveImageDimensions(image);
    }, { once: true });
  }

  function fixImageDimensions() {
    doc.querySelectorAll('.custom-logo img, .custom-footer img, img.cat-img, img.product-card-img').forEach(reserveImageDimensions);
  }

  function syncDisclosure(trigger, panel, open) {
    if (!trigger || !panel) return;
    var panelId = panel.id || safeId((trigger.closest('[id]') || {}).id || 'disclosure') + '-panel';
    panel.id = panelId;
    trigger.setAttribute('aria-controls', panelId);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    panel.setAttribute('role', 'region');
  }

  function fixLanguageSwitcher() {
    doc.querySelectorAll('.lang-switcher').forEach(function (wrapper, index) {
      var trigger = wrapper.querySelector('.lang-switcher-toggle');
      var menu = wrapper.querySelector('.lang-switcher-menu');
      if (!trigger || !menu) return;
      if (!menu.id) menu.id = index === 0 ? 'HeaderLanguageMenu' : 'HeaderLanguageMenu-' + (index + 1);
      trigger.setAttribute('aria-controls', menu.id);
    });
  }

  function syncFaqAccessibility() {
    doc.querySelectorAll('.faq-section-wrapper').forEach(function (wrapper) {
      syncDisclosure(
        wrapper.querySelector('.faq-section-trigger'),
        wrapper.querySelector('.faq-list-wrapper'),
        wrapper.classList.contains('open')
      );
    });

    doc.querySelectorAll('.faq-item').forEach(function (item) {
      syncDisclosure(
        item.querySelector('.faq-trigger'),
        item.querySelector('.faq-content-wrapper'),
        item.classList.contains('open')
      );
    });
  }

  function fixLegacyHiddenCartLinks() {
    doc.querySelectorAll('.tt-header-holder .tt-cart .item-html-js.hide a[href="#"]').forEach(function (link) {
      link.setAttribute('href', '/cart');
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
    });
  }

  function applyFixes() {
    if (!isHomepage()) return;
    applyHomepageTitle();
    fixDuplicateFormIds();
    fixDuplicateSvgIds();
    fixImageDimensions();
    fixLanguageSwitcher();
    syncFaqAccessibility();
    fixLegacyHiddenCartLinks();
    applied = true;
  }

  function startObserver() {
    if (!root.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      var shouldSyncFaq = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'class' &&
          mutation.target.matches && mutation.target.matches('.faq-section-wrapper, .faq-item');
      });
      if (shouldSyncFaq) syncFaqAccessibility();
    });
    observer.observe(doc.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () {
      applyFixes();
      startObserver();
    }, { once: true });
  } else {
    applyFixes();
    startObserver();
  }

  root.addEventListener('load', function () {
    applyFixes();
  }, { once: true });

  root.HanezzaHomeQualityFixes = {
    apply: applyFixes,
    get applied() { return applied; }
  };
})(typeof window !== 'undefined' ? window : null);

//# debugId=057ad2ba-d577-5484-93ca-3a6cf477cf88
